import { Address } from '../redux/types';

export function formatAddress(address: Address) {
    const countryString = address.country ? `${address.country},` : '';
    return `${address.streetAddress.join(', ')}, ${address.city}, ${address.state}, ${countryString} ${
        address.zipCode
    }`;
}
